import React, { useState } from "react";
import { sendNewsletter } from "../../services/storeApi";
import { SyncLoader } from "react-spinners";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSignUp = async (e) => {
    e.preventDefault(); // prevent form reload
    setIsSubmitting(true);
    if (!email || !email.includes("@")) {
      setIsSubmitting(false)
      alert("Please enter a valid email address");
      return;
    }

    try {
      await sendNewsletter({email});
      setIsSubmitting(false)
      alert("🎉 You are now subscribed!");
      setEmail(""); // clear input
    } catch (error) {
      console.error("Error subscribing:", error);
      setIsSubmitting(false)
      alert("Something went wrong. Please try again later.");
    }
  };

  return (
    <section
      className="newsletter bg-light"
      style={{
        background: "url('../../assets/images/pattern-bg.png') no-repeat center center / cover",
      }}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8 py-5 my-5">
            <div className="subscribe-header text-center pb-3">
              <h3 className="section-title text-uppercase">
                Sign Up for Our Newsletter
              </h3>
              <p className="text-muted small">
                Get the latest fashion updates and bulk offers straight to your inbox.
              </p>
            </div>

            <form
              onSubmit={handleSignUp}
              className="d-flex flex-wrap gap-2 justify-content-center"
            >
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your Email Address"
                className="form-control form-control-lg flex-grow-1"
                required
              />
              <button
                type="submit"
                className="btn btn-dark btn-lg text-uppercase px-4 w-100"
              >
               {!isSubmitting? "Sign Up": <SyncLoader color="#ffffff"/> }
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
